import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import { filter, get, map, reverse, sortBy, sum } from 'lodash';
import { provincesMap } from './vietnam-province-map'

@Component({
  selector: 'app-vietnam-map',
  templateUrl: './vietnam-map.component.html',
  styleUrls: ['./vietnam-map.component.scss']
})
export class VietnamMapComponent implements OnInit, OnChanges {
  @Input() chartTitle: string;
  @Input() data: IProvinceMap[] = [];
  @Input() showDetail: boolean = true;
  @Input() chartHeight: any = 500;
  @Input() chartWidth: any = 500;
  @Output() hoverMap: EventEmitter<any> = new EventEmitter<any>();

  dataView: IProvinceMap[] = [];
  dataMap: IProvinceMap[] = [];
  totalPost: number;

  private geoData: any;
  map: any;
  polygonSeries: any = [];

  constructor() { }

  ngOnInit() {
    this.loadMap();
  }

  ngOnChanges() {
    if (this.geoData) {
      this.buildMap();
    }
  }

  loadMap() {
    fetch('/assets/data/diaphantinh.json')
      .then((r) => r.json())
      .then((geodata) => {
        this.geoData = geodata;
        this.buildMap();
      });
  }

  buildMap() {
    const dataTransformed = JSON.parse(JSON.stringify(this.data));
    this.dataView = reverse(sortBy(filter(dataTransformed, v => v['count'] > 0), 'count'));
    this.dataMap = this.dataView.filter(c => c.province_name);
    let otherProvinceIndex = this.dataView.findIndex(c => !c.province_name);
    if (otherProvinceIndex >= 0) {
      this.dataView[otherProvinceIndex].province_name = 'Khác'
    }
    // if (this.dataView.map(v => v.province_name).includes("Unknown")) {
    //     this.sortData();
    // }
    this.totalPost = sum(map(this.dataView, 'count'));
    this.buildVietnamMapChart();
  }

  buildVietnamMapChart() {
    const self = this;
    this.map = am4core.create('vietnamMap', am4maps.MapChart);
    this.map.exporting.menu = new am4core.ExportMenu();
    // Set map definition
    this.map.geodata = this.geoData;
    am4core.options.autoSetClassName = true;
    // Set projection
    // Pre-zoom the map
    //this.map.zoomControl = new am4maps.ZoomControl();
    this.map.maxZoomLevel = 1;
    // Set projection
    this.map.projection = new am4maps.projections.Miller();
    // Create map polygon series
    const series = new am4maps.MapPolygonSeries();
    series.id = 'test';
    this.polygonSeries = this.map.series.push(series);
    // Exclude Antartica
    // this.polygonSeries.exclude = ['AQ'];
    // Make map load polygon (like country names) data from GeoJSON
    this.polygonSeries.useGeodata = true;
    // Make map load polygon (like country names) data from GeoJSON
    this.polygonSeries.useGeodata = true;
    // Configure series
    const polygonTemplate = this.polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = '{name}';
    polygonTemplate.fill = am4core.color('#979a9c');
    // polygonTemplate.stroke = am4core.color('#41962d');
    polygonTemplate.stroke = am4core.color('#ffffff');
    // Create hover state and set alternative fill color
    const hs = polygonTemplate.states.create('hover');
    hs.properties.fill = am4core.color('#979a9c');
    const hl = polygonTemplate.states.create('highlight');
    hl.properties.fill = am4core.color('#0063B8');

    this.dataMap.forEach((v: IProvinceMap, k: number) => {
      const series1 = self.map.series.push(new am4maps.MapPolygonSeries());
      series1.name = v.province_name;
      series1.count = v.count;
      series1.useGeodata = true;
      series1.include = [get(provincesMap.find(x => x.name.toLowerCase() === v.province_name.toLowerCase() || x.name_eng.toLowerCase() == v.province_name.toLowerCase()), 'id')];
      series1.mapPolygons.template.align = 'center';
      series1.mapPolygons.template.valign = 'middle';
      series1.simplifiedProcessing = true;
      series1.mapPolygons.template.tooltipText = '{name}: {count} Bài viết';
      // series1.mapPolygons.template.tooltipHTML = '<div><b>{name}</b><br>Some text more text blah<br>OK let\'s try even longer text how it goes<br>No? Hmmm<br>Still no<br>Still no<br>Still no<br>Still no<br></div>';
      // series1.mapPolygons.template.showTooltipOn = 'always';
      // series1.mapPolygons.template.alwaysShowTooltip = true;
      // series1.mapPolygons.template.tooltipPosition = 'fixed';
      series1.mapPolygons.template.zIndex = 999999;
      const color = k !== 0 ? "#FFBF48" : "#ec3e3f";
      series1.mapPolygons.template.fill = am4core.color(color);
      series1.fill = am4core.color(color);
    });


    this.polygonSeries.mapPolygons.template.events.on('over', this.setAreaActiveOnHover, this);
    this.polygonSeries.mapPolygons.template.events.on('out', this.setDefaultActive, this);
    // Add expectancy data (custom data)
    polygonTemplate.propertyFields.fill = 'fill';
    this.polygonSeries.data = JSON.parse(JSON.stringify(this.dataMap));
  }

  setAreaActiveOnHover(ev) {
    this.hoverMap.emit(ev.target.dataItem.dataContext);
  }

  setDefaultActive(ev) {
    this.hoverMap.emit(null);
  }
}
export interface IProvinceMap {
  province_name: string;
  count: number;
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/vietnam-map/vietnam-map.component.ts